import React from 'react';
import { withStyles } from '@material-ui/core';
import styles from '../ProcessPurchaseOrdersDialog/ProcessPurchaseOrdersDialog.styles';
import { IProcessPurchaseOrdersActionGridProps } from '../ProcessPurchaseOrdersDialogs.properties';
import DataGrid from 'devextreme-react/data-grid';
import { useRetrievePurchaseOrdersProcessActions } from 'api/purchaseOrders/purchaseOrders';
import { usePOContextSelector, usePODispatch } from 'components/PurchaseOrders/PurchaseOrders.context';
import { Content, Heading } from './CommonComponents';
import DynamicDataGrid from 'components/common/DataGridDevEx/DynamicDataGrid';
import { columns } from '../ProcessPurchaseOrdersDialogs.constants';
import BasicLookupActionField from 'components/FormView/Fields/BasicLookupActionField';

const ProcessPurchaseOrdersActionGrid = (props: IProcessPurchaseOrdersActionGridProps) => {
    const {
        classes,
        userId,
        linesCount
    } = props;

    const params = new URLSearchParams(location.search);
    const PurchaseOrder = usePOContextSelector<'PurchaseOrder'>((state) => state.PurchaseOrder) || params.get('PurchaseOrder');
    const dataGridInnerRef = React.useRef<DataGrid>();
    const [isFirstTimeLoad, setIsFirstTimeLoad] = React.useState<boolean>(true);
    const [PurchaseOrdersProcessActions, setPurchaseOrdersProcessActions] = React.useState(null);
    const [description, setDescription] = React.useState(null);

    const retrievePurchaseOrdersProcessActionsMutation = useRetrievePurchaseOrdersProcessActions();

    const contextDispatch = usePODispatch();
    const ProcessPurchaseOrderDetails = usePOContextSelector<'ProcessPurchaseOrderDetails'>((state) => state.ProcessPurchaseOrderDetails);
    const POSummary = usePOContextSelector<'SummaryPanelData'>((state) => state.SummaryPanelData);

    React.useEffect(
        () => {
            retrievePurchaseOrdersProcessActionsMutation.mutateAsync({
                SearchText: '',
                PurchaseOrder
            }).then((response) => {
                if (linesCount === 0) {
                    setPurchaseOrdersProcessActions(
                        response?.Data.filter((item) => (item.Code === 'C'))
                    );
                } else {
                    setPurchaseOrdersProcessActions(response?.Data);
                }
            });
        },
        [PurchaseOrder]
    );

    const selectionChanged = React.useCallback(
        (e) => {
            const selectedRowData = e?.selectedRowsData?.length > 0 ? e.selectedRowsData[0] : undefined;
            if (selectedRowData) {
                contextDispatch({ setProcessPurchaseOrderDetails: { ...ProcessPurchaseOrderDetails, Action: selectedRowData?.Code } });
                setDescription(selectedRowData?.Description);
            }
        },
        []);

    const onContentReady = React.useCallback(
        async () => {
            if (dataGridInnerRef.current?.instance?.getDataSource()?.items().length > 0 && isFirstTimeLoad) {

                if (ProcessPurchaseOrderDetails?.Action) {
                    await dataGridInnerRef.current?.instance.selectRows([ProcessPurchaseOrderDetails?.Action], false);
                } else {
                    dataGridInnerRef.current.instance.selectRowsByIndexes([0])
                        .catch((err) => console.warn(err));
                    //update the model in first loading
                    const firstRowKey = dataGridInnerRef.current.instance.getKeyByRowIndex(0);
                    contextDispatch({ setProcessPurchaseOrderDetails: { ...ProcessPurchaseOrderDetails, Action: firstRowKey } });
                }

                setIsFirstTimeLoad(false);
            }
        },
        [isFirstTimeLoad, ProcessPurchaseOrderDetails, dataGridInnerRef.current]
    );

    const OnSelectionChanged = (value: any) => {
        if (value && value.Code !== '') {
            contextDispatch({ setProcessPurchaseOrderDetails: { ...ProcessPurchaseOrderDetails, UserId: value.Code } });
        }
    };

    const isDisabled = (): boolean => {
        if (ProcessPurchaseOrderDetails?.Action === 'PT') {
            return false;
        } else if (ProcessPurchaseOrderDetails?.Action === 'C' && (POSummary?.PurchaseOrderStatus?.toLowerCase() === 't' || POSummary?.PurchaseOrderStatus?.toLowerCase() === 'm')) {
            return false;
        } else {
            return true;
        }
    };

    return (
        <div className={classes.contentContainer}>
            <Heading text='Depending on current status of the purchase order, actions below can be selected' />
            <DynamicDataGrid
                dataGridClassName={classes.dataGrid}
                columns={columns}
                allowHeaderFilting={false}
                allowUpdating={false}
                allowDelete={false}
                actionButtonsVisibility={false}
                selection='single'
                gridProps={{
                    dataSource: PurchaseOrdersProcessActions,
                    dataGridRef: dataGridInnerRef,
                    onContentReady: onContentReady,
                    onSelectionChanged: selectionChanged,
                    allowColumnResizing: true,
                    sorting: { mode: 'none' },
                    keyExpr: 'Code'
                }}
            />
            <Content text={description} />
            <BasicLookupActionField
                placeholder={'User ID'}
                label={'User ID'}
                size={'small'}
                searchScreenTitle={'User ID'}
                lookupName={'Personnel'}
                value={userId?.toString()}
                required
                onSelectedItemChange={(item) => OnSelectionChanged(item as any)}
                suppressDescription={false}
                descriptionField={'Label'}
                column1Field='Display'
                column2Field='Description'
                disabled={isDisabled()}
            />
        </div>
    );
};

export default withStyles(styles, { index: 1 })(ProcessPurchaseOrdersActionGrid);
